import React__default from 'react';
import classNames from 'classnames';
import { variationName } from '../../../../utilities/css.mjs';
import { TopBarSpacingValue, TopBarPaddedValue } from './types.mjs';
import styles from './LayoutGroup.scss.mjs';
import { useFeatures } from '../../../FeaturesProvider/FeaturesProvider.mjs';
import { Item } from './components/Item/Item.mjs';

function LayoutGroup({
  children,
  grow = false,
  shrink = false,
  center = false,
  alignRight = false,
  padded = false,
  spacing = TopBarSpacingValue.Base,
  distributeSpace = false,
  alignBaseline = false
}) {
  const {
    usesBottomSheet
  } = useFeatures();
  const layoutGroupClassNames = classNames(styles.LayoutGroup, {
    [styles.grow]: grow,
    [styles.shrink]: shrink,
    [styles.center]: center,
    [styles.alignRight]: alignRight,
    [styles[variationName('spacing', spacing)]]: Boolean(spacing),
    [styles.distributeSpace]: distributeSpace,
    [styles[variationName('padded', getPaddedKey(padded))]]: padded,
    [styles.usesBottomSheet]: usesBottomSheet,
    [styles.alignBaseline]: alignBaseline
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: layoutGroupClassNames
  }, children);
}
function getPaddedKey(padded) {
  return typeof padded === 'string' ? padded : TopBarPaddedValue.Both;
}
LayoutGroup.Item = Item;

export { LayoutGroup };
